import React from "react";
import '../Modal.scss';
import { Stepper, Step, StepLabel } from '@mui/material'

export default function ModalHeader(props){

    function getStepper(){
        return <Stepper activeStep={props.activeStep - 1}>
                    {props.steps.map((label) => (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
    }

    return (
        <div className='modalHeader'>
            {
                props.stepper ? getStepper() : 
                <h2>
                    {props.text}
                </h2>
            }
            {
                props.secondText && <h3>{props.secondText}</h3>
            }
        </div>
    )
}